import { render, staticRenderFns } from "./BackAction.vue?vue&type=template&id=14a0e1be&scoped=true&"
import script from "./BackAction.vue?vue&type=script&lang=js&"
export * from "./BackAction.vue?vue&type=script&lang=js&"
import style0 from "./BackAction.vue?vue&type=style&index=0&id=14a0e1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a0e1be",
  null
  
)

export default component.exports